import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {Box, styled, Typography} from "@mui/material";
import React from "react";
import {FactorInterface} from "../../interfaces/FactorInterface";
import Factor from "./Factor";

interface AIMenuAnalyticsInterface {
    percents: number[];
    articles: FactorInterface[][]
}

const AIMenuAnalyticsContainer = styled(Box)({
    marginTop: "20px",
});

const AIMenuAnalyticsItemsContainer = styled(Box)({
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    columnGap: "10px",
    "&:last-of-type":{
        marginTop: "10px",
    }
});

const AIMenuAnalyticsItemText = styled(Typography)({
    fontSize: "20px",
    fontWeight: 600,
    color: "#D3D3D3",
    width: "100%",
    textAlign: "center",
});

const AIMenuAnalyticsFactorsContainer = styled(Box)({
    display: "flex",
    gap: "10px",
    flexFlow: "wrap",
});

export const StyledTitleSmall = styled(Box)({
    fontSize: "clamp(10px, 16px, 20px)",
    fontWeight: 600,
    color: "#D3D3D3",
    width: "100%",
    textAlign: "center",
    borderBottom: "1px solid #A9A9A9",
    "& p":{
        fontSize: "10px",
        margin: "2px",
        fontWeight: 400,
        color: "#A9A9A9",
    }
});

const AIMenuAnalytics = ({percents, articles}: AIMenuAnalyticsInterface):JSX.Element => {
    
    const colors = ["#B30000", "#F1C40F", "#5bbf83"];
    
    const renderPercents = ():React.ReactNode => {
        return (
            <>
                {percents.map((opt, index) => {
                    return (
                        <Box key={"percents-" + index}>
                            <AIMenuAnalyticsItemText>{opt} %</AIMenuAnalyticsItemText>
                        </Box>
                    );
                })}
            </>
        );
    };
    
    const renderFactors = ():React.ReactNode => {
        return (
            <>
                {articles.map((opt, i) => {
                    return (
                        <Box key={"factors-" + i}>
                            <AIMenuAnalyticsFactorsContainer>
                                {opt.map((el, index) => {
                                    return <Factor article={el} key={"dropFactor-" + index} color={colors[i]}/>;
                                })}
                            </AIMenuAnalyticsFactorsContainer>
                        </Box>
                    );
                })}
            </>
        );
    };
    
    return (
        <AIMenuAnalyticsContainer>
            <StyledTitleSmall>
                AI calculations of probabilities for this asset
                <p>(based on open source analysis)</p>
            </StyledTitleSmall>
            <Box sx={{
                padding: "15px 10px"
            }}>
                <AIMenuAnalyticsItemsContainer>
                    <AIMenuAnalyticsItemText>
                        <TrendingDownIcon htmlColor={"#B30000"}/>
                    </AIMenuAnalyticsItemText>
                    <AIMenuAnalyticsItemText>
                        <TrendingFlatIcon htmlColor={"#F1C40F"}/>
                    </AIMenuAnalyticsItemText>
                    <AIMenuAnalyticsItemText>
                        <TrendingUpIcon htmlColor={"#5bbf83"}/>
                    </AIMenuAnalyticsItemText>
                </AIMenuAnalyticsItemsContainer>
                <AIMenuAnalyticsItemsContainer>
                    {renderPercents()}
                </AIMenuAnalyticsItemsContainer>
                <AIMenuAnalyticsItemsContainer>
                    {renderFactors()}
                </AIMenuAnalyticsItemsContainer>
            </Box>
        </AIMenuAnalyticsContainer>
    );
};

export default AIMenuAnalytics;
